import classnames from 'classnames';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { matchPath, RouteComponentProps, useLocation, withRouter } from 'react-router';
import { Link } from 'react-router-dom';

import logo from '../../../../assets/images/logo.svg';
import logo_white from '../../../../assets/images/logo_white.svg';
import { SocialNetworks } from '../../../../components/SocialNetworks';
import { ROUTES } from '../../../../router/consts';
import { IApplicationState } from '../../../../store/models';
import { ETextColor } from '../../../Projects/enums';
import { setHeaderColor } from '../../store/actions';
import { IHeaderState } from '../../store/models';

import './index.scss';

interface IProps extends RouteComponentProps { }

const HeaderDumb: React.SFC<IProps> = ({ history }) => {
    const dispatch = useDispatch();
    const [isMenuVisible, setMenuVisibility] = React.useState(false);
    const [isBurgerButtonOut, setBurgerButtonOut] = React.useState(false);

    const headerState = useSelector<IApplicationState, IHeaderState>((state) => state.layout.header);
    const buttonRef = React.useRef<HTMLButtonElement>(null);
    const { pathname } = useLocation();

    React.useEffect(
        () => {
            history.listen(location => {
                setMenuVisibility(false);
                dispatch(setHeaderColor(ETextColor.BLACK));
            });
        },
        [history, dispatch],
    );

    React.useEffect(
        () => {
            window.addEventListener('scroll', () => {
                const isHome = !!matchPath(pathname, { path: ROUTES.HOME, exact: true });

                if (buttonRef && buttonRef.current && isHome) {
                    const windowHeight = window.innerHeight;
                    const scrollLimit = windowHeight - buttonRef.current.offsetTop;

                    if (window.scrollY >= scrollLimit) {
                        setBurgerButtonOut(true);
                    } else {
                        setBurgerButtonOut(false);
                    }
                }
            });
        },
        [pathname],
    );

    return (
        <div className={classnames('container header', { header__white: headerState.slider_text_color === ETextColor.WHITE })}>
            <header>
                <Link to={ROUTES.HOME}>
                    <img className="logo" src={headerState.slider_text_color === ETextColor.WHITE ? logo_white : logo} alt="" />
                </Link>
                <Link className="header__contacts" to={ROUTES.CONTACT.MAIN}>Contacts</Link>

                <div
                    className={
                        classnames(
                            'menu',
                            {
                                active: isMenuVisible,
                            }
                        )
                    }
                >
                    <Link to={ROUTES.LOGIN}>
                        <div className="personal-account">
                            <i className="icon-personal" />
                            Personal Account
                        </div>
                    </Link>
                    <div className="menu__list">
                        <ul>
                            <li>
                                <Link to={ROUTES.AGENCY}>Agency</Link>
                            </li>
                            <li>
                                <Link to={ROUTES.PROJECTS}>Projects</Link>
                            </li>
                            <li>
                                <Link to={ROUTES.CAREERS}>Careers</Link>
                            </li>
                            <li>
                                <Link to={ROUTES.CONTACT.MAIN}>Contacts</Link>
                            </li>
                        </ul>
                    </div>
                    <SocialNetworks />
                </div>
            </header>
            <button
                type="button"
                ref={buttonRef}
                onClick={() => setMenuVisibility(!isMenuVisible)}
                className={classnames(
                    'header__menu-hamburger',
                    `header__menu-hamburger--${headerState.slider_text_color}`,
                    {
                        active: isMenuVisible,
                        out: isBurgerButtonOut,
                    }
                )}
            >
                <span />
            </button>
        </div >
    );
};

export const Header = withRouter(HeaderDumb);
